import { SxProps, Theme } from "@mui/material";

export const bannerStyles: SxProps<Theme> = {
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 1000,
  padding: { xs: "12px 14px", sm: "14px 20px" },
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
  backgroundColor: "#0f172a",
  color: "white",
  boxShadow: "0 -4px 20px rgba(15, 23, 42, 0.25)",
};

export const contentStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  flex: 1,
  minWidth: 0,
};

export const titleStyles: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: { xs: "13px", sm: "15px" },
  lineHeight: 1.3,
};

export const subtitleStyles: SxProps<Theme> = {
  fontSize: { xs: "11px", sm: "13px" },
  color: "rgba(255, 255, 255, 0.78)",
  lineHeight: 1.3,
};

export const installButtonStyles: SxProps<Theme> = {
  flexShrink: 0,
  background: "linear-gradient(90deg, #06B6D4 0%, #8B5CF6 100%)",
  color: "white",
  fontWeight: 600,
  fontSize: { xs: "12px", sm: "14px" },
  textTransform: "none",
  borderRadius: "8px",
  px: { xs: 1.5, sm: 2 },
  py: 0.75,
  "&:hover": {
    background: "linear-gradient(90deg, #0891B2 0%, #7C3AED 100%)",
  },
};

export const closeButtonStyles: SxProps<Theme> = {
  color: "rgba(255, 255, 255, 0.8)",
  flexShrink: 0,
  "&:hover": {
    color: "white",
    backgroundColor: "rgba(255, 255, 255, 0.08)",
  },
};

export const dialogStepStyles: SxProps<Theme> = {
  fontSize: "14px",
  lineHeight: 1.5,
  mb: 1.5,
};